import React from 'react';

import Period from 'components/Period';

import { Tooltip } from '@gogame/components';
import { useScreenState } from '@gogame/screens';

const FilterView = ({ base, baseTooltip }) => (
  <React.Fragment>
    <Tooltip title={baseTooltip} wrapper>
      {base}
    </Tooltip>
  </React.Fragment>
);

const KPIPresetsDescription = () => {
  const screenState = useScreenState();
  const { period } = screenState;
  return <FilterView base={<Period value={period} />} baseTooltip={'Period'} />;
};

export default KPIPresetsDescription;
